export const promisifyLoadImg = (src, w, h) => {
  return new Promise((resolve, reject) => {
    const img = new Image(w, h);
    img.src = src;
    img.onload = () => resolve(img);
    img.onerror = error => reject(error);
  })
}